export default __webpack_public_path__ + "static/media/welcome-banner-icon.155d5ec6.png";